import { IconButton } from "@mui/material";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { Fragment } from "react";

export default function FiltersApplied(props: any) {
  // Group search filters and keep other filters separate
  const processFilters = () => {
    const searchFilters = props.filters.filter((filter: any) => filter.type === 'search');
    const otherFilters = props.filters.filter((filter: any) => filter.type !== 'search');
    
    const processedFilters = [];
    
    // Add grouped search filter if any exist
    if (searchFilters.length > 0) {
      // Use the value from the first search filter for display
      const searchValue = searchFilters[0].value;
      const displayValue = typeof searchValue === 'string' && searchValue.length > 10 
        ? searchValue.substring(0, 10) + "..." 
        : searchValue;
      
      processedFilters.push({
        type: 'search_group',
        displayText: `${displayValue}`,
        searchFilters: searchFilters,
        isGroup: true
      });
    }
    
    // Add other filters
    otherFilters.forEach((filter: any) => {
      processedFilters.push({
        ...filter,
        isGroup: false
      });
    });
    
    return processedFilters;
  };

  const processedFilters = processFilters();

  return (
    <Fragment>
      {/* SHOWS ONLY IF PROPS.FILTERS EXISTS AND IS NOT EMPTY */}
      {props.filters.length > 0 && (
        <div className="filtersApplied">
          Filters applied:
          {processedFilters.map((filter: any, index: any) => {
            let displayText;

            if (filter.isGroup && filter.type === 'search_group') {
              // Display for grouped search filters
              displayText = filter.displayText;
            } else if (filter.type === 'order') {
              // Display for ordering
              displayText = `Sort by: ${filter.label}`;
            } else if (filter.type === 'date_range' && filter.value.startDate && filter.value.endDate) {
              // Display for date range filters
              const value = `${filter.value.startDate} - ${filter.value.endDate}`;
              displayText = `${value}`;
            } else {
              // Display for other filters
              let value;
              if (typeof filter.value === 'string') {
                // If it's a string, cut it if longer than 10 characters
                value = filter.value.length < 10 ? filter.value : filter.value.substring(0, 10) + "...";
              } else {
                // For other cases, display the value as is
                value = JSON.stringify(filter.value);
              }

              // Combine label, condition, and value for display
              displayText = `${filter.label} ${filter.condition} ${value}`;
            }

            return (
              <div className="filterItem" key={index}>
                <span>{displayText}</span>
                <IconButton
                  size="small"
                  onClick={() => {
                    if (filter.isGroup && filter.type === 'search_group') {
                      // Remove all search filters
                      const newFilters = props.filters.filter((f: any) => f.type !== 'search');
                      props.setFilters(newFilters);
                    } else {
                      // Remove the specific filter by finding it in the original array
                      // We need to find the original filter by its properties since the processed filter is a copy
                      const newFilters = props.filters.filter((originalFilter: any) => {
                        // Compare key properties to identify the same filter
                        return !(originalFilter.key === filter.key && 
                                originalFilter.value === filter.value && 
                                originalFilter.type === filter.type &&
                                originalFilter.condition === filter.condition);
                      });
                      props.setFilters(newFilters);
                    }
                  }}
                >
                  <DeleteOutlineOutlinedIcon sx={{ fontSize: 15 }} />
                </IconButton>
              </div>
            );
          })}
        </div>
      )}
    </Fragment>
  );
}
